<template>
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Entries</label>
          <v-select
            v-model="pagination.perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="pagination.perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            variant="primary"
            @click="
              $router.push({
                name: tag_type.tag_type_name + '-form',
                params: {
                  tag_id: 'new',
                  tag_type_name: tag_type.tag_type_name,
                },
              })
            "
          >
            Add {{ tag_type.tag_type_description }}
          </b-button>
        </b-col>

        <!-- Search -->
        <!-- <b-col cols="12" md="6">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="filters.search"
              class="d-inline-block mr-1"
              placeholder="Search..."
            />
            <v-select
              v-model="filters.statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="invoice-filter-select"
              placeholder="Select Status"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select>
          </div>
        </b-col> -->
      </b-row>
    </div>

    <b-table
      ref="refTagList"
      :items="tags_list"
      responsive
      :fields="tableColumns"
      :per-page="pagination.perPage"
      :current-page="pagination.currentPage"
      primary-key="tag_id"
      show-empty
      empty-text="No matching records found"
      class="position-relative"
    >
      <template #cell(index)="data">
        {{ tags_list.indexOf(data.item) + 1 }}
      </template>
      <!-- Column: Actions -->
      <template #cell(edit)="data">
        <div class="text-nowrap">
          <feather-icon
            :id="`tag-row-${data.item.tag_id}-edit-icon`"
            icon="EditIcon"
            size="16"
            class="mx-1"
            @click="
              $router.push({
                name: tag_type.tag_type_name + '-form',
                params: {
                  tag_id: data.item.tag_id,
                  tag_type_name: tag_type.tag_type_name,
                },
              })
            "
          />
          <b-tooltip
            :title="'Edit ' + tag_type.tag_type_description"
            :target="`tag-row-${data.item.tag_id}-edit-icon`"
          />
        </div>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="
            d-flex
            align-items-center
            justify-content-center justify-content-sm-start
          "
        >
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="
            d-flex
            align-items-center
            justify-content-center justify-content-sm-end
          "
        >
          <b-pagination
            v-model="pagination.currentPage"
            :total-rows="totalTags"
            :per-page="pagination.perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import MasterServices from "@/apiServices/MasterServices";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
  },
  computed: {
    totalTags() {
      return this.tags_list.length;
    },
  },
  watch: {
    "$route.params.tag_type_name": {
      handler: function () {
        this.beforeMountFun();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      tag_type: {},
      tableColumns: [
        { key: "index", label: "#", sortable: false },
        { key: "tag_name", label: "Name", sortable: false },
        { key: "edit", label: "Edit", sortable: false },
      ],
      tags_list: [],
      pagination: {
        currentPage: 1,
        perPage: 10,
        perPageOptions: [5, 10, 20, 30],
      },
      filters: {
        search: null,
      },
    };
  },
  methods: {
    async getTagsList(tag_type_name) {
      try {
        const response = await MasterServices.getTags({ tag_type_name });
        if (response.data.status) {
          this.tags_list = response.data.data;
        }
      } catch (err) {
        console.log("Error in getting all tags ", err);
      }
    },
    async getTagTypeDetails(tag_type_name) {
      try {
        const response = await MasterServices.getTagTypeDetails({
          tag_type_name,
        });
        if (response.data.status) {
          this.tag_type = response.data.data;
        }
      } catch (err) {
        console.log("Error in getTagTypeDetails ", err);
      }
    },
    beforeMountFun() {
      const { tag_type_name } = this.$route.params;
      if (tag_type_name) {
        this.getTagsList(tag_type_name);
        this.getTagTypeDetails(tag_type_name);
      }
    },
  },
  beforeMount() {
    this.beforeMountFun();
  },
};
</script>

<style>
</style>